/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { queryEncode } from 'cio/helpers/query';
import serializeFilters from 'cio/utils/conditions/serialize/filter';
import { SerializedLegacySegmentNegatableFilter } from 'cio/types/conditions/legacy-filter';

type Props = {
  anchors: SerializedLegacySegmentNegatableFilter[];
  filters: SerializedLegacySegmentNegatableFilter[];
};

export default class PeopleMatchingConditionsLink extends Component<Props> {
  get anchors() {
    return this.args.anchors ?? [];
  }

  get filters() {
    return this.args.filters ?? [];
  }

  get _peopleQueryString() {
    return queryEncode(serializeFilters([...this.anchors, ...this.filters], 'and', true));
  }

  get _peopleQueryStringText() {
    let conditions = [];

    if (!isEmpty(this.args.anchors)) {
      conditions.push('trigger');
    }

    if (!isEmpty(this.args.filters)) {
      conditions.push('filter');
    }

    return conditions.join(' and ');
  }
}
